import range from 'lodash/range';
import React from 'react';
import T from 'prop-types';
import Table from '@splunk/dashboard-visualizations/Table';
import SuiTable from '@splunk/react-ui/Table';

/**
 * A custom cell renderer react component
 */
const CustomCell = ({ value, cellOptions, fieldOptions, onCellClick }) => {
    // eslint-disable-next-line no-console
    console.log('cellOptions', cellOptions);
    // eslint-disable-next-line no-console
    console.log('fieldOptions', fieldOptions);
    const { type, align } = fieldOptions;
    const style = {
        backgroundColor: type === 'number' && value % 2 === 0 ? 'red' : 'green',
        color: 'black',
    };
    return (
        <SuiTable.Cell style={style} align={align} test-cell-type="string" onClick={onCellClick}>
            {`value=${value}`}
        </SuiTable.Cell>
    );
};

CustomCell.propTypes = {
    onCellClick: T.func,
    value: T.oneOfType([T.number, T.string, T.array]).isRequired,
    cellOptions: T.object,
    fieldOptions: T.object,
};

/**
 * indicate whether this cell renderer can be used for particular cell
 */
CustomCell.canRender = (field, fieldOptions, value) => {
    // eslint-disable-next-line no-console
    console.log('field', field);
    // eslint-disable-next-line no-console
    console.log('fieldOptions', fieldOptions);
    // eslint-disable-next-line no-console
    console.log('field value', value);
    // always use this renderer
    return true;
};

export default () => (
    <Table
        options={{}}
        encoding={{
            columns: 'primary[0]',
        }}
        cellRenderers={[CustomCell]}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    fields: ['count'],
                    columns: [range(10)],
                },
            },
        }}
    />
);
